module.exports = __webpack_public_path__ + "static/media/21-min.81d704f8.jpg";